<section class="credit-card">
  <!-- CREDIT CARD -->
  <div
    *ngIf="isTheFrontOfTheCard; else isTheBackOfTheCard"
    class="credit-card__visual"
    [ngClass]="{
      'credit-card__visa animated fadeIn':
        creditCardForm.get('cardNumber').value &&
        creditCardForm.get('cardNumber').value.toString().startsWith('4'),
      'credit-card__master animated fadeIn':
        creditCardForm.get('cardNumber').value &&
        creditCardForm.get('cardNumber').value.toString().startsWith('5'),
      'credit-card__amex animated fadeIn':
        creditCardForm.get('cardNumber').value &&
        creditCardForm.get('cardNumber').value.toString().startsWith('3'),
      'credit-card__discover animated fadeIn': setCreditCardBackground()
    }"
  >
    <div
      *ngIf="creditCardForm.get('cardNumber').value"
      class="credit-card__visual-type"
    >
      <fa-icon class="animated fadeIn" [icon]="creditCardType"></fa-icon>
    </div>

    <h2
      class="credit-card__visual-number"
      *ngIf="creditCardForm.get('cardNumber').value"
    >
      {{ creditCardForm.get("cardNumber").value }}
    </h2>

    <h3
      class="credit-card__visual-holder"
      *ngIf="creditCardForm.get('cardHolder').value"
    >
      {{ creditCardForm.get("cardHolder").value }}
    </h3>

    <p
      class="credit-card__visual-year"
      *ngIf="creditCardForm.get('cardExpirationYear').value"
    >
      {{ creditCardForm.get("cardExpirationYear").value }}
    </p>

    <p
      class="credit-card__visual-month"
      *ngIf="creditCardForm.get('cardExpirationMonth').value"
    >
      {{ creditCardForm.get("cardExpirationMonth").value }}
    </p>
  </div>

  <ng-template #isTheBackOfTheCard>
    <div
      class="credit-card__visual flip-vertical-right"
      [ngClass]="{
        'credit-card__visa animated fadeIn':
          creditCardForm.get('cardNumber').value &&
          creditCardForm.get('cardNumber').value.toString().startsWith('4'),
        'credit-card__master animated fadeIn':
          creditCardForm.get('cardNumber').value &&
          creditCardForm.get('cardNumber').value.toString().startsWith('5'),
        'credit-card__amex animated fadeIn':
          creditCardForm.get('cardNumber').value &&
          creditCardForm.get('cardNumber').value.toString().startsWith('3'),
        'credit-card__discover animated fadeIn': setCreditCardBackground()
      }"
    >
      <div class="credit-card__visual-security-band"></div>
      <section class="credit-card__visual-ccv-section">
        <p class="credit-card__visual-holder-band">
          {{
            creditCardForm.get("cardNumber").value
              | slice
                : creditCardForm.get("cardNumber").value.length - 4
                : creditCardForm.get("cardNumber").value.length
          }}
        </p>
        <p class="credit-card__visual-ccv">
          {{ creditCardForm.get("cardCCV").value }}
        </p>
      </section>
    </div>
  </ng-template>
  <!-- CREDIT CARD -->

  <!-- FORM -->
  <form
    class="credit-card__form"
    [formGroup]="creditCardForm"
    autocomplete="off"
    (ngSubmit)="addCard()"
  >
    <div class="credit-card__form-group">
      <label for="cardNumber" class="credit-card__form-label"
        >Card Number
        <input
          type="text"
          formControlName="cardNumber"
          id="cardNumber"
          class="credit-card__form-input"
          only-numbers
          string-separated-each-four-characters
          maxlength="19"
        />
      </label>
      <app-form-error *ngIf="cardNumberNoValid"></app-form-error>
    </div>

    <div class="credit-card__form-group">
      <label for="cardHolder" class="credit-card__form-label"
        >Card Holder
        <input
          type="text"
          formControlName="cardHolder"
          id="cardHolder"
          only-letters
          class="credit-card__form-input"
          maxlength="20"
          [disabled]="
            isDisabled(
              creditCardForm.get('cardNumber').value.toString().length > 12,
              'cardHolder'
            )
          "
        />
      </label>
      <app-form-error *ngIf="cardHolderNoValid"></app-form-error>
    </div>

    <div class="credit-card__form-group">
      <label for="cardExpirationYear" class="credit-card__form-label"
        >Expiration Year
        <select
          name="cardExpirationYear"
          id="cardExpirationYear"
          formControlName="cardExpirationYear"
          class="credit-card__form-input"
          [disabled]="
            isDisabled(
              creditCardForm.get('cardHolder').value.toString().length > 6,
              'cardExpirationYear'
            )
          "
        >
          <option *ngFor="let year of expirationYears" [value]="year">
            {{ year }}
          </option>
        </select>
      </label>
      <app-form-error *ngIf="cardExpirationYearNoValid"></app-form-error>
    </div>

    <div class="credit-card__form-group">
      <label for="cardExpirationMonth" class="credit-card__form-label"
        >Expiration Month
        <select
          name="cardExpirationMonth"
          id="cardExpirationMonth"
          formControlName="cardExpirationMonth"
          class="credit-card__form-input"
          [disabled]="
            isDisabled(
              creditCardForm.get('cardExpirationYear').value,
              'cardExpirationMonth'
            )
          "
        >
          <option *ngFor="let month of expirationMonths" [value]="month.value">
            {{ month.name }}
          </option>
        </select>
      </label>
      <app-form-error *ngIf="cardExpirationMonthNoValid"></app-form-error>
    </div>

    <div class="credit-card__form-group">
      <label for="cardCCV" class="credit-card__form-label"
        >CCV
        <input
          type="text"
          only-numbers
          formControlName="cardCCV"
          id="cardCCV"
          class="credit-card__form-input"
          maxlength="3"
          [disabled]="
            isDisabled(
              creditCardForm.get('cardExpirationMonth').value,
              'cardCCV'
            )
          "
        />
      </label>
      <app-form-error *ngIf="cardCCVNoValid"></app-form-error>
    </div>

    <div class="credit-card__form-group submit-container">
      <button
        [disabled]="creditCardForm.invalid"
        class="credit-card__form-submit"
        type="submit"
      >
        {{ updateCard ? "Update Card" : "Add Card" }}
      </button>
    </div>
  </form>
  <!-- FORM -->
</section>
